module.exports = __webpack_public_path__ + "static/img/logo_black_big.9f2f48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black_big.png
// module id = Gilq
// module chunks = 13